/* global angular, swal, _ */
export default ($scope, $q, $log, $stateParams, $uibModalInstance, $timeout, Swal, selectedEmployees, ApiClass) => {
  'ngInject';
  $scope.resultsQueried = false;

  $scope.assignEmployeesTrack = function(tracks) {
    const selectedTracks = tracks.filter(({ selected }) => selected);
    if (!selectedTracks.length) {
      swal('Error', 'Select one or more tracks', 'error');
      $uibModalInstance.close('cancel');
    } else {
      return Promise.all(
        selectedTracks.map(selectedTrack =>
          ApiClass.learningsIdTypePut(
            { id: selectedTrack.track_id, type: 'assigned' },
            {
              assignedTrackParams: selectedEmployees.map(({ profile_uid }) => {
                return { profile_uid };
              })
            },
            { queryParams: { manage: true } }
          )
        )
      )
        .then(() => {
          Swal.toast('Assigned!');
          $scope.cancel('success');
        })
        .catch(error => {
          $scope.cancel();
          $log.error(error);
          throw error;
        });
    }
  };

  $scope.cancel = function(message) {
    $uibModalInstance.close(message || 'cancel');
  };

  ApiClass.learningsGet(
    {},
    {},
    {
      queryParams: {
        manage: true,
        filters: JSON.stringify({
          active: true
        })
      }
    }
  )
    .then(({ data: { tracks } }) => {
      $scope.allTracks = tracks;
      $scope.resultsQueried = true;
    })
    .catch(error => {
      $log.error(error);
      throw error;
    });
};



// WEBPACK FOOTER //
// ./src/app/modals/employeesTracks/index.js